import React from 'react';
import { Message } from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';
import useInterval from '@restart/hooks/useInterval';

import { setToast } from '../../store/ToastManagement';

import './toast.css';

export const ToastProvider = () => {
  const dispatch = useDispatch();
  const dismiss = () => dispatch(setToast(null));

  const toast = useSelector(state => state.toastManagement.toast);

  useInterval(
    () => {
      dismiss();
    },
    (toast && toast.duration) || 3000,
    !toast
  );

  if (!toast) {
    return null;
  }

  const isSuccess = toast && toast.success === undefined ? true : toast.success;

  const color = isSuccess ? 'teal' : 'red';

  return (
    <div className="tel-toast">
      <Message onDismiss={dismiss} color={color} size="massive" floating>
        {toast.title && <Message.Header>{toast.title}</Message.Header>}
        {toast.body && <p>{toast.body}</p>}
      </Message>
    </div>
  );
};
